// @ts-nocheck
//https://nf404.github.io/crypto-api/crypto-api.min.js

export function generatePepper(pepperInput: string) {
  // step toBase64
  const stepToBase64 = btoa(pepperInput);

  // step toBinary
  let stepToBinary = "";
  for (const element of stepToBase64.split("")) {
    const toB = element.charCodeAt(0).toString(2);
    stepToBinary += "00000000".slice(toB.length) + toB + " ";
  }
  stepToBinary = stepToBinary.trim();

  // step sum
  let stepSum = 0;
  for (const element of stepToBinary.split(" ")) {
    stepSum += Number.parseInt(element);
  }

  // step ADD
  const utf8Encode = new TextEncoder();
  const addInput = utf8Encode.encode(stepSum);
  const addKey = new Float64Array(1);
  addKey[0] = 3.1415;

  // algorithm based on CyberChef implementation (https://github.com/gchq/CyberChef/blob/master/src/core/operations/ADD.mjs)
  const addResult = [];
  // eslint-disable-next-line unicorn/no-null
  let x = null;
  // eslint-disable-next-line unicorn/no-null
  let k = null;
  // eslint-disable-next-line unicorn/no-null
  let o = null;
  for (const [i, element] of addInput.entries()) {
    k = addKey[i % addKey.length];
    o = element;
    x = o === 0 || o === k ? o : (o + k) % 256;
    addResult.push(x);
  }
  const utf8Decode = new TextDecoder();
  const stepAdd = utf8Decode.decode(new Int8Array(addResult));

  // step second toBinary
  let stepToBinarySecond = "";
  for (const element of stepAdd.split("")) {
    const toB = element.charCodeAt(0).toString(2);
    stepToBinarySecond += "00000000".slice(toB.length) + toB + " ";
  }
  stepToBinarySecond = stepToBinarySecond.trim();

  // step second toBase64
  const stepToBase64Second = btoa(stepToBinarySecond);

  return stepToBase64Second;
}

export function hashWithSHA384(input: string) {
  const hasher = CryptoApi.getHasher("sha384");
  hasher.update(input);

  return CryptoApi.encoder.toHex(hasher.finalize());
}
